module.exports = __webpack_public_path__ + "static/img/conversion-3.0372d8f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/conversion-3.svg
// module id = 1426
// module chunks = 0